import React, { useState, useRef } from "react";
import {
  ddiLogo,
  dhiLogo,
  doctors,
  flower,
  leaf,
  leaf2,
  logo,
  mainLeaf,
} from "../../assets";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoYoutube,
  BiLogoTwitter,
  BiLogoLinkedin,
} from "react-icons/bi";
import { BsBookmarkPlus } from "react-icons/bs";
import { CiLocationOn, CiPhone } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const form = useRef();
  const navigate = useNavigate();

  const [uname, setUname] = useState("");
  const [unum, setUnum] = useState("");
  const [uemail, setUemail] = useState("");
  const [uSub, setUsub] = useState("");
  const [umsg, setUmsg] = useState("");

  const reset = () => {
    setUname("");
    setUnum("");
    setUemail("");
    setUsub("");
    setUmsg("");
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_t15vteq",
        "template_3lyo8sq",
        form.current,
        "wLuR42rWS-d2I4PgN"
      )
      .then(
        toast.success("Message sent Successfully", {
          position: "top-center",
          autoClose: 1000,
        })
      )
      .catch((err) =>
        toast.error("Something went wrong", {
          position: "top-center",
          autoClose: 1000,
        })
      );

    reset();
  };

  return (
    <div id="contactPage">
      <img src={mainLeaf} alt="" className="mainLeaf" />
      <img src={flower} alt="" className="mainLeaf2" />
      <img src={leaf2} alt="" className="mainLeaf3" />
      <img src={mainLeaf} alt="" className="mainLeaf4" />

      <motion.div
        className="bannerTitle"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <div className="left">
          <img src={leaf} alt="" />
          <h1>We are Committed to Your Health and Beauty</h1>
          <h3>For Emergencies: Call (+880 12345678) </h3>

          <button className="booking" onClick={() => navigate("/appointment")}>
           
            <small>Book Appointment</small>
          </button>
        </div>
        <div className="right">
          <iframe
            src="https://www.youtube.com/embed/i11TceowUT0"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen={true}
            className="banani"
          ></iframe>
        </div>
      </motion.div>

      <motion.div
        className="top"
        whileInView={{ opacity: [0, 1], x: [-50, 0] }}
        transition={{ duration: 0.7 }}
      >
        <div className="brances">
          <motion.div
            whileInView={{ opacity: [0, 1], x: [50, 0] }}
            transition={{ duration: 0.7 }}
            className="LT"
          >
            <div className="left">
              <img src={logo} alt="" />
              <h2 className="helpline">HELPLINE: +88 09678 006 007</h2>
            </div>
            <div className="right">
              <h1>LASER TREAT</h1>

              <div className="contact-details">
                <div className="num">
                  <h2>CONTACT NUMBER</h2>
                  <p>
                    <CiPhone className="phn" /> Banani: +88 017 500 100 20, +88
                    017 500 100 30
                  </p>
                  <p>
                    <CiPhone className="phn" />
                    Uttara: +88 017 500 100 26, +88 017 500 100 28
                  </p>
                </div>
                <div className="add">
                  <h2>CONTACT ADDRESS</h2>
                  <p>
                    <CiLocationOn className="loc" />
                    Banani: The Laureate, House: 56 (3rd Floor), Road: 11,
                    Block: F, Banani, Dhaka-1213, Bangladesh.
                  </p>
                  <p>
                    <CiLocationOn className="loc" />
                    Uttara:Garibe Newaz Avenue, Plot No: 30 (4th Floor),
                    Sector:13, Uttara, Dhaka-1230, Bangladesh.
                  </p>
                </div>
              </div>

              <div className="social-links">
                <Link to="/">
                  <BiLogoFacebook className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoInstagramAlt className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoYoutube className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoTwitter className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoLinkedin className="socialIO" />
                </Link>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="DDI"
            whileInView={{ opacity: [0, 1], x: [-50, 0] }}
            transition={{ duration: 0.7 }}
          >
            <div className="left">
              <img src={ddiLogo} alt="" />
              <h2 className="helpline">HELPLINE: +88 09678 006 007</h2>
            </div>
            <div className="right">
              <h1>DHAKA DERMATOLOGY INSTITUTE</h1>

              <div className="contact-details">
                <div className="num">
                  <h2>CONTACT NUMBER</h2>
                  <p>
                    <CiPhone className="phn" /> Banani: +88 017 500 100 20, +88
                    017 500 100 30
                  </p>
                  <p>
                    <CiPhone className="phn" />
                    Uttara: +88 017 500 100 26, +88 017 500 100 28
                  </p>
                </div>
                <div className="add">
                  <h2>CONTACT ADDRESS</h2>
                  <p>
                    <CiLocationOn className="loc" />
                    Banani: The Laureate, House: 56 (3rd Floor), Road: 11,
                    Block: F, Banani, Dhaka-1213, Bangladesh.
                  </p>
                  <p>
                    <CiLocationOn className="loc" />
                    Uttara:Garibe Newaz Avenue, Plot No: 30 (4th Floor),
                    Sector:13, Uttara, Dhaka-1230, Bangladesh.
                  </p>
                </div>
              </div>

              <div className="social-links">
                <Link to="/">
                  <BiLogoFacebook className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoInstagramAlt className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoYoutube className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoTwitter className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoLinkedin className="socialIO" />
                </Link>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="DHI"
            whileInView={{ opacity: [0, 1], x: [50, 0] }}
            transition={{ duration: 0.7 }}
          >
            <div className="left">
              <img src={dhiLogo} alt="" />
              <h2 className="helpline">HELPLINE: +88 09678 006 007</h2>
            </div>
            <div className="right">
              <h1>DIRECT HAIR IMPLANTATION (DHI)</h1>

              <div className="contact-details">
                <div className="num">
                  <h2>CONTACT NUMBER</h2>
                  <p>
                    <CiPhone className="phn" /> Banani: +88 017 500 100 20, +88
                    017 500 100 30
                  </p>
                  <p>
                    <CiPhone className="phn" />
                    Uttara: +88 017 500 100 26, +88 017 500 100 28
                  </p>
                </div>
                <div className="add">
                  <h2>CONTACT ADDRESS</h2>
                  <p>
                    <CiLocationOn className="loc" />
                    Banani: The Laureate, House: 56 (3rd Floor), Road: 11,
                    Block: F, Banani, Dhaka-1213, Bangladesh.
                  </p>
                  <p>
                    <CiLocationOn className="loc" />
                    Uttara:Garibe Newaz Avenue, Plot No: 30 (4th Floor),
                    Sector:13, Uttara, Dhaka-1230, Bangladesh.
                  </p>
                </div>
              </div>

              <div className="social-links">
                <Link to="/">
                  <BiLogoFacebook className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoInstagramAlt className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoYoutube className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoTwitter className="socialIO" />
                </Link>
                <Link to="/">
                  <BiLogoLinkedin className="socialIO" />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        className="bottom"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <div className="title">
          <h1>Get in Touch</h1>
          <p>Fill up the form and our team will get back to you soon</p>
        </div>

        <div className="formArea">
          <div className="formControl">
            <form ref={form} onSubmit={sendEmail}>
              <div className="form-grp fullName">
                <p>Full Name:</p>
                <input
                  type="text"
                  id=""
                  name="from_name"
                  value={uname}
                  onChange={(e) => setUname(e.target.value)}
                  required
                />
              </div>
              <div className="form-grp num">
                <p>Your Mobile:</p>
                <input
                  type="tel"
                  name="from_num"
                  id=""
                  value={unum}
                  onChange={(e) => setUnum(e.target.value)}
                  required
                />
              </div>
              <div className="form-grp email">
                <p>Your Email:</p>
                <input
                  type="email"
                  name="from_email"
                  id=""
                  value={uemail}
                  onChange={(e) => setUemail(e.target.value)}
                  required
                />
              </div>
              <div className="form-grp subject">
                <p>Subject:</p>
                <input
                  type="text"
                  name="from_sub"
                  value={uSub}
                  id=""
                  onChange={(e) => setUsub(e.target.value)}
                />
              </div>
              <div className="form-grp msg">
                <p>Message:</p>
                <textarea
                  type="text"
                  name="message"
                  id=""
                  draggable={false}
                  value={umsg}
                  onChange={(e) => setUmsg(e.target.value)}
                  required
                />
              </div>

              <button type="submit">Send Message</button>
            </form>
          </div>
          <div className="additional">
            <img src={doctors} alt="" />
          </div>
        </div>
      </motion.div>

      <div className="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.779814158976!2d90.4005926761071!3d23.79085388722062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c70ded40cdd3%3A0xa7d973e48d73df6f!2sLaser%20Treat%20Banani%20Branch!5e0!3m2!1sen!2sbd!4v1691481594224!5m2!1sen!2sbd"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="bananiMap"
        ></iframe>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
